import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';



export interface CreateKeyDialogData {
  workspaceName: string;
}

@Component({
  selector: 'app-create-workspace-key-dialog',
  imports: [],
  templateUrl: './create-workspace-key-dialog.component.html',
  styleUrl: './create-workspace-key-dialog.component.css'
})
export class CreateWorkspaceKeyDialogComponent {
  isLoading = false;

  constructor(
    public dialogRef: MatDialogRef<CreateWorkspaceKeyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CreateKeyDialogData
  ) {}

  onCancel(): void {
    if (!this.isLoading) {
      this.dialogRef.close(false);
    }
  }

  onCreate(): void {
    this.isLoading = true;
    this.dialogRef.close(true);
  }
}